  import React from 'react';
import { Search, CircleX } from 'lucide-react';
import { StyledSearchInput } from './Table/Table.styled';
import Loader from '../Loader';
import {
  SearchInputWrapper,
  SearchInputContainer,
  SearchIconWrapper,
  ClearSearchButton,
  SearchLoaderWrapper,
} from '../HotelsTable/HotelsTable.styled';

interface SearchInputProps {
  placeholder?: string;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onClearSearch: (props?: any) => void;
  onEnterPress?: () => void;
  isSearchLoading: boolean;
  disabled?: boolean;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder  = "Search Hotels...",
  searchTerm,
  onSearchChange,
  onClearSearch,
  onEnterPress,
  isSearchLoading,
  disabled = false,
  className
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onEnterPress) {
      onEnterPress();
    }
  };

  const handleSearchChange = (value: string) => {
    // If the current search is empty and user is trying to add only spaces, prevent it
    if (searchTerm.trim().length === 0 && value.trim().length === 0) {
      return;
    }
    onSearchChange(value);
  };

  return (
    <SearchInputWrapper className={className}> 
      <SearchInputContainer style={{ cursor: disabled ? 'not-allowed' : 'default' }}>
        <SearchIconWrapper>
          <Search className="w-4 h-4" />
        </SearchIconWrapper>
        <StyledSearchInput
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={e => handleSearchChange(e.target.value)}
          onKeyDown={handleKeyDown}
          className="w-full"
          disabled = {disabled}
          style={{ cursor: disabled ? 'not-allowed' : 'text' }}
        />
            </SearchInputContainer>
      {!isSearchLoading && searchTerm.length > 0 && (
        <ClearSearchButton onClick={onClearSearch}>
          <CircleX className="text-[var(--color-error)]" size={20} />
        </ClearSearchButton>
      )}
      {isSearchLoading && (
        <SearchLoaderWrapper>
          <Loader spinnerClassName="w-4 h-4 border-2" />
        </SearchLoaderWrapper>
      )}
    </SearchInputWrapper>
  );
};

export default SearchInput;
